/* eslint-disable @typescript-eslint/no-explicit-any */

export function enumToArray(enumType: any): KeyValuePair<string, number>[] {
    return Object.keys(enumType)
        .filter(key => isNaN(Number(key)))
        .map((key) => {
            return { key: key, value: enumType[key] };
        });
}

export interface KeyValuePair<K, V> {
    key: K;
    value: V;
}
